// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MainFooter_wrapper_1CCJi","variant-light":"MainFooter_variant-light_Z4Wqz","variant-dark":"MainFooter_variant-dark_3W1Uj"};